<template>
    <t-space direction="vertical" align="start" style="width: 100%;">
        <t-space></t-space>
        <t-space direction="horizontal" style="width: 100%;">
            <t-space></t-space>
            <t-card title="搜索栏" style="width: 85.5vw;">
                <t-space direction="horizontal">
                    <t-input v-model="searchName" placeholder="请输入名称"></t-input>
                    <t-input v-model="searchType" placeholder="请输入类型"></t-input>
                    <t-checkbox v-model="searchHavePay">应收应付不为0</t-checkbox>
                    <t-button theme="primary" variant="base" @click="Search">搜索</t-button>
                </t-space>
            </t-card>
            <t-space></t-space>
        </t-space>
        <t-space direction="horizontal" style="width: 100%;">
            <t-space></t-space>
            <t-card title="供应商/客户列表" style="width: 85.5vw;">
                <t-space direction="vertical">
                    <t-button @click="()=>{ showAddDialog = true }">新增供应商/客户</t-button>
                    <t-table
                        row-key="index"
                        :data="tableData"
                        cell-empty-content="-"
                        :pagination="pageConfig"
                        :columns="columns">
                    </t-table>
                </t-space>
            </t-card>
            <t-space></t-space>
        </t-space>
        <!--详情页查看窗口-->
        <t-dialog
            width="85.5vw"
            header="详情"
            :visible="showDetilsDialog"
            @close="() => { showDetilsDialog = false}"
            @cancel="() => { showDetilsDialog = false}"
            @confirm="() => { showDetilsDialog = false}">
            <t-descriptions bordered :column="3">
                <t-descriptions-item label="姓名">{{ detilsShowData.name }}</t-descriptions-item>
                <t-descriptions-item label="类型">{{ detilsShowData.type }}</t-descriptions-item>
                <t-descriptions-item label="创建时间">{{ detilsShowData.createTime }}</t-descriptions-item>
                <t-descriptions-item label="应收应付">{{ detilsShowData.advanceCredit }}</t-descriptions-item>
                <t-descriptions-item label="开户行">{{ detilsShowData.accountBankName }}</t-descriptions-item>
                <t-descriptions-item label="银行账户">{{ detilsShowData.bankAccount }}</t-descriptions-item>
                <t-descriptions-item label="纳税人识别号">{{ detilsShowData.identificationNumberOfTheTaxpayer }}</t-descriptions-item>
                <t-descriptions-item label="地址">{{ detilsShowData.address }}</t-descriptions-item>
                <t-descriptions-item label="手机号">{{ detilsShowData.phoneNumber }}</t-descriptions-item>
            </t-descriptions>
        </t-dialog>
        <!--消账目窗口-->
        <t-dialog
            theme="info"
            header="如果类型为客户则为收款，为供应商则为付款"
            :visible="showPayDialog"
            @close="() => { showPayDialog = false}"
            @cancel="() => { showPayDialog = false}"
            @confirm="requestPay">
            <t-row justify="left">
                <t-col>
                    应收应付款：<t-input-number v-model="payValue" placeholder="请输入付款金额" auto-width suffix="元"></t-input-number>
                </t-col>
            </t-row>
        </t-dialog>
        <!--加账目窗口-->
        <t-dialog
            theme="info"
            header="如果为客户则为待收，为供应商则为欠款"
            :visible="showDisPayDialog"
            @close="() => { showDisPayDialog = false}"
            @cancel="() => { showDisPayDialog = false}"
            @confirm="requestDisPay">
            <t-row justify="left">
                <t-col>
                    待收待还款：<t-input-number v-model="payValue" placeholder="请输入付款金额" auto-width suffix="元"></t-input-number>
                </t-col>
            </t-row>
        </t-dialog>
        <!--修改信息窗口-->
        <t-dialog
            header="修改"
            :visible="showModifyDialog"
            @close="() => {showModifyDialog = false}"
            @cancel="() => {showModifyDialog = false}"
            @confirm="requestModify">
            <t-form ref="modifyForm" :data="modifyFormData" :rules="formRules">
                <t-form-item name="name" label="名称">
                    <t-input v-model="modifyFormData.name" placeholder="请输入名称"></t-input>
                </t-form-item>
                <t-form-item name="type" label="类型">
                    <t-radio-group v-model="modifyFormData.type">
                        <t-radio value="客户">客户</t-radio>
                        <t-radio value="供应商">供应商</t-radio>
                    </t-radio-group>
                </t-form-item>
                <t-form-item name="accountBankName" label="开户行">
                    <t-input v-model="modifyFormData.account_bank_name" placeholder="请输入开户行"></t-input>
                </t-form-item>
                <t-form-item name="bankAccount" label="银行账号">
                    <t-input v-model="modifyFormData.bank_account" placeholder="请输入银行账号"></t-input>
                </t-form-item>
                <t-form-item name="identificationNumberOfTheTaxPayer" label="纳税人识别号">
                    <t-input v-model="modifyFormData.identification_number_of_the_taxpayer" placeholder="请输入纳税人识别号"></t-input>
                </t-form-item>
                <t-form-item name="address" label="地址">
                    <t-input v-model="modifyFormData.address" placeholder="请输入地址"></t-input>
                </t-form-item>
                <t-form-item name="phoneNumber" label="手机号">
                    <t-input v-model="modifyFormData.phone_number" placeholder="请输入手机号"></t-input>
                </t-form-item>
            </t-form>
        </t-dialog>
        <!--新增窗口-->
        <t-dialog
            header="新增"
            :visible="showAddDialog"
            @close="() => {showAddDialog = false}"
            @cancel="() => {showAddDialog = false}"
            @confirm="AddCooperativePartner">
            <t-form ref="addForm" :data="addFormData" :rules="formRules">
                <t-form-item name="name" label="名称">
                    <t-input v-model="addFormData.name" placeholder="请输入名称"></t-input>
                </t-form-item>
                <t-form-item name="type" label="类型">
                    <t-radio-group v-model="addFormData.type">
                        <t-radio value="客户">客户</t-radio>
                        <t-radio value="供应商">供应商</t-radio>
                    </t-radio-group>
                </t-form-item>
                <t-form-item name="advance_credit" label="应收应付">
                    <t-input-number v-model="addFormData.advance_credit" placeholder="请输入应收应付" auto-width suffix="元"></t-input-number>
                </t-form-item>
                <t-form-item name="account_bank_name" label="开户行">
                    <t-input v-model="addFormData.account_bank_name" placeholder="请输入开户行"></t-input>
                </t-form-item>
                <t-form-item name="bank_account" label="银行账号">
                    <t-input v-model="addFormData.bank_account" placeholder="请输入银行账号"></t-input>
                </t-form-item>
                <t-form-item name="identification_number_of_the_taxpayer" label="纳税人识别号">
                    <t-input v-model="addFormData.identification_number_of_the_taxpayer" placeholder="请输入纳税人识别号"></t-input>
                </t-form-item>
                <t-form-item name="address" label="地址">
                    <t-input v-model="addFormData.address" placeholder="请输入地址"></t-input>
                </t-form-item>
                <t-form-item name="phoneNumber" label="手机号">
                    <t-input v-model="addFormData.phone_number" placeholder="请输入手机号"></t-input>
                </t-form-item>
            </t-form>
        </t-dialog>
    </t-space>
</template>

<script lang="jsx" setup>
import request from '@/request/request';
import { NotifyPlugin } from 'tdesign-vue-next';
import { onMounted, ref } from 'vue';

const searchName = ref('')
const searchType = ref('')
const searchHavePay = ref(false)

const addForm = ref()
const modifyForm = ref()
const showDetilsDialog = ref(false)
const showPayDialog = ref(false)
const showDisPayDialog = ref(false)

const showModifyDialog = ref(false)
const showAddDialog = ref(false)

const detilsShowData = ref({})

const payValue = ref()
const payId = ref()

const formRules = {
    name: [{required: true, message: '姓名必填', type: 'error'}],
    type: [{required: true, message: '类型必填', type: 'error'}],
    advance_credit: [{required: true, message: '应收应付必填，若无则为0', type: 'error'}],
}
const modifyFormData = ref({
    name: "",
    type: "",
    create_time: "",
    payable: "",
    receivable: "",
    account_bank_name: "",
    bank_account: "",
    identification_number_of_the_taxpayer: "",
    address: "",
    phone_number: ""
})
const addFormData = ref({
    name: "",
    type: "",
    advance_credit: "",
    account_bank_name: "",
    bank_account: "",
    identification_number_of_the_taxpayer: "",
    address: "",
    phone_number: ""
})

const tableData = ref([])

const columns = [
    { title: '名称', colKey: 'name'},
    { title: '类型', colKey: 'type'},
    { title: '创建日期', colKey: 'createTime'},
    { title: '应收/应付', colKey: 'advanceCredit'},
    {
        title: '操作栏',
        colKey: 'operate',
        width: 250,
        cell: (h, { row }) => {
            console.log("ROW INDEX",row)
            return (
                <t-space class="table-operations" space="small">
                    <t-link theme="primary" hover="color" data-id={row.index} onClick={onDetils}>
                        详情
                    </t-link>
                    <t-link theme="success" hover="color" data-id={row.index} onClick={receivableOrPay}>
                        消账
                    </t-link>
                    <t-link theme="warning" hover="color" data-id={row.index} onClick={disPay}>
                        添账
                    </t-link>
                    <t-link theme="primary" hover="color" data-id={row.index} onClick={onModify}>
                        修改
                    </t-link>
                    <t-link theme="danger" hover="color" data-id={row.index} onClick={onDelete}>
                        删除
                    </t-link>
            </t-space>
            );
        }
    }
]
const pageConfig = ref({
    pageSize: 8, 
    defaultCurrent: 1, 
    defaultPageSize: 8,
    total: 100,
    showPageSize: false,
    onCurrentChange: (number)=>{
        //请求分页数据
        const params = {
            page_number: number,
            page_size: pageConfig.value.pageSize,
            binding_user_id: parseInt(sessionStorage.getItem("user_id"))
        }
        if(searchName.value !== '' && searchName.value) params.name = searchName.value
        if(searchType.value !== '' && searchType.value) params.type = searchType.value
        if(searchHavePay.value !== '' && searchHavePay.value) params.has_advance_credit = searchHavePay.value
        fetchCopperativePartnerData(params)
    }
})
onMounted(()=>{
    //请求分页数据和页数数量
    const params = {
        page_number: 1,
        page_size: pageConfig.value.pageSize,
        binding_user_id: parseInt(sessionStorage.getItem("user_id"))
    }
    fetchCopperativePartnerData(params)
})

const fetchCopperativePartnerData= (params)=>{
    request.SearchCooperativePartnerList(params,(res)=>{
        if(res.data.success) {
            pageConfig.value.total = res.data.data.total
            tableData.value = res.data.data.resultList
            for(let i = 0; i < tableData.value.length; i++) {
                tableData.value[i].index = i
            }
        }else{
            NotifyPlugin.error({
                placement: 'top-right',
                title: '数据请求错误',
                content: '数据请求失败，其联系管理人员\n',
                duration: 3000,
            })
        }
    },
    (err)=>{
        NotifyPlugin.error({
            placement: 'top-right',
            title: '数据请求错误',
            content: '数据请求失败，其联系管理人员\n' + err,
            duration: 3000,
        })
    })
}
const AddCooperativePartner = ()=>{
    request.AddCooperativePartner(addFormData,(res)=>{
        if(res.data.success) {
            NotifyPlugin.success({
                placement: 'top-right',
                title: '添加成功',
                content: '数据添加成功',
                duration: 3000,
            })
            pageConfig.value.total++
            if(!(tableData.value.length >= pageConfig.value.pageSize)) {
                let addData = {
                    index: tableData.value.length,
                    id: res.data.data,
                    name: addFormData.value.name,
                    type: addFormData.value.type,
                    advanceCredit: addFormData.value.advance_credit,
                    accountBankName: addFormData.value.account_bank_name,
                    bankAccount: addFormData.value.bank_account,
                    identificationNumberOfTheTaxPayer: addFormData.value.identification_number_of_the_taxpayer,
                    address: addFormData.value.address,
                    phoneNumber: addFormData.value.phoneNumber
                }
                tableData.value.push(addData)
            }
        }else {
            NotifyPlugin.error({
                placement: 'top-right',
                title: '数据请求错误',
                content: '数据请求失败，其联系管理人员\n',
                duration: 3000,
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            placement: 'top-right',
            title: '数据请求错误',
            content: '数据请求失败，其联系管理人员\n' + err,
            duration: 3000,
        })
    })
    showAddDialog.value = false
}
const onDetils = (e)=>{
    const id = e.currentTarget.dataset.id
    detilsShowData.value = tableData.value[id]
    showDetilsDialog.value = true
}

const onModify = (e)=>{
    const id = e.currentTarget.dataset.id
    modifyFormData.value.id = tableData.value[id].id
    modifyFormData.value.name = tableData.value[id].name
    modifyFormData.value.type = tableData.value[id].type
    modifyFormData.value.advance_credit = tableData.value[id].advanceCredit
    modifyFormData.value.account_bank_name = tableData.value[id].accountBankName
    modifyFormData.value.bank_account = tableData.value[id].bankAccount
    modifyFormData.value.identification_number_of_the_taxpayer = tableData.value[id].identificationNumberOfTheTaxpayer
    modifyFormData.value.address = tableData.value[id].address
    modifyFormData.value.phone_number = tableData.value[id].phoneNumber
    modifyFormData.value.index = id
    showModifyDialog.value = true
}

const onDelete = (e)=>{
    const id = e.currentTarget.dataset.id
    request.DeleteCooperativePartner(tableData.value[id].id,
    (res)=>{
        if(res.data.success) {
            NotifyPlugin.success({
                placement: 'top-right',
                title: '删除成功',
                content: '数据删除成功',
                duration: 3000,
            })
            pageConfig.value.total--
            tableData.value.splice(id,1)
        }else{
            NotifyPlugin.error({
                placement: 'top-right',
                title: '删除失败',
                content: '删除失败，其联系管理人员\n',
                duration: 3000,
            })
        }
    },
    (err)=>{
        NotifyPlugin.error({
            placement: 'top-right',
            title: '删除失败',
            content: '删除失败，其联系管理人员\n' + err,
            duration: 3000,
        })
    })

}

const receivableOrPay = (e)=>{
    payId.value = e.currentTarget.dataset.id
    showPayDialog.value = true
}

const disPay = (e)=>{
    payId.value = e.currentTarget.dataset.id
    showDisPayDialog.value = true
}
const requestDisPay = ()=>{
    request.DisPayCooperativePartnerMVP(tableData.value[payId.value].id,payValue.value,
    (res)=>{
        if(res.data.success) {
            NotifyPlugin.success({
                placement: 'top-right',
                title: '操作成功',
                content: '操作成功',
                duration: 3000,
            })
            tableData.value[payId.value].advanceCredit = parseFloat(tableData.value[payId.value].advanceCredit) + payValue.value
        } else {
            NotifyPlugin.error({
                placement: 'top-right',
                title: '操作失败',
                content: '操作失败，其联系管理人员\n' + res.data.tag,
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            placement: 'top-right',
            title: '操作失败',
            content: '操作失败，请联系管理人员\n' + err,
        })
    })
    showDisPayDialog.value = false
}
const requestPay = ()=>{
    request.PayCooperativePartnerMVP(tableData.value[payId.value].id,payValue.value,
    (res)=>{
        if(res.data.success) {
            NotifyPlugin.success({
                placement: 'top-right',
                title: '操作成功',
                content: '操作成功',
                duration: 3000,
            })
            tableData.value[payId.value].advanceCredit = tableData.value[payId.value].advanceCredit - payValue.value
        } else {
            NotifyPlugin.error({
                placement: 'top-right',
                title: '操作失败',
                content: '操作失败，其联系管理人员\n' + res.data.tag,
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            placement: 'top-right',
            title: '操作失败',
            content: '操作失败，请联系管理人员\n' + err,
        })
    })
    showPayDialog.value = false
}

const requestModify = ()=>{
    request.ModifyCooperativePartner(modifyFormData,
    (res)=>{
        if(res.data.success) {
            NotifyPlugin.success({
                placement: 'top-right',
                title: '修改成功',
                content: '数据修改成功',
                duration: 3000,
            })
            //TODO 格式命名的问题
            tableData.value[modifyFormData.value.index].name = modifyFormData.value.name
            tableData.value[modifyFormData.value.index].type = modifyFormData.value.type
            tableData.value[modifyFormData.value.index].advanceCredit = modifyFormData.value.advance_credit
            tableData.value[modifyFormData.value.index].accountBankName = modifyFormData.value.account_bank_name
            tableData.value[modifyFormData.value.index].bankAccount = modifyFormData.value.bank_account
            tableData.value[modifyFormData.value.index].identificationNumberOfTheTaxpayer = modifyFormData.value.identification_number_of_the_taxpayer
            tableData.value[modifyFormData.value.index].address = modifyFormData.value.address
            tableData.value[modifyFormData.value.index].phoneNumber = modifyFormData.value.phone_number
            showModifyDialog.value = false
        }else {
            NotifyPlugin.error({
                placement: 'top-right',
                title: '修改失败',
                content: '数据请求失败，其联系管理人员\n',
                duration: 3000,
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            placement: 'top-right',
            title: '修改失败',
            content: '数据请求失败，其联系管理人员\n' + err,
            duration: 3000,
        })
    })
}

const Search = ()=>{
    //请求分页数据
    const params = {
        page_number: 1,
        page_size: pageConfig.value.pageSize,
        binding_user_id: parseInt(sessionStorage.getItem("user_id"))
    }
    if(searchName.value !== '' && searchName.value) params.name = searchName.value
    if(searchType.value !== '' && searchType.value) params.type = searchType.value
    if(searchHavePay.value !== '' && searchHavePay.value) params.has_advance_credit = searchHavePay.value
    fetchCopperativePartnerData(params)
}

</script>

<style lang="scss" scoped>
</style>